<script lang="ts" setup>
import { useMeta } from "vue-meta";

const TITLE = "디포스트, 일상에 혁신을 더하는 순간";
const TEXT_DESCRIPTION =
  "문서수발실의 새로운 변화 디지털 메일룸 디포스트. 우리 회사의 문서수발실이 불편하신가요? 기업과 건물에 맞는 비즈니스 컨시어지 솔루션, 디포스트에 맡겨보세요.";
const SITE_URL = "https://dpost.co.kr";

// useMeta를 이용하여 title, meta 태그 등을 설정
useMeta({
  title: TITLE,
  titleTemplate: "%s | 디포스트",
  meta: [
    {
      vmid: "description",
      name: "description",
      content: TEXT_DESCRIPTION,
    },

    { vmid: "og:type", name: "og:type", content: "website" },
    { vmid: "og:title", name: "og:title", content: TITLE },
    {
      vmid: "og:description",
      name: "og:description",
      content: TEXT_DESCRIPTION,
    },
    {
      vmid: "og:url",
      name: "og:url",
      content: `${SITE_URL}`,
    },
    {
      vmid: "og:image",
      name: "og:image",
      content: `${SITE_URL}/images/dp_icon_1200x627.png`,
    },
    {
      vmid: "twitter:card",
      name: "twitter:card",
      content: `summary`,
    },
    {
      vmid: "twitter:title",
      name: "twitter:title",
      content: TITLE,
    },
    {
      vmid: "twitter:description",
      name: "twitter:description",
      content: TEXT_DESCRIPTION,
    },
    {
      vmid: "twitter:image",
      name: "twitter:image",
      content: `${SITE_URL}/images/dp_icon_1200x627.png`,
    },
  ],
});
</script>

<template>
  <metainfo>
    <template v-slot:title="{ content, metainfo }">
      {{
        metainfo.titleTemplate
          ? metainfo.titleTemplate.replace("%s", content)
          : content
      }}
    </template>
  </metainfo>
  <router-view />
</template>

<style lang="scss">
@import "@/assets/style/index.scss";
</style>
